// Reserved (RFC 6761) TLD that never resolves — a stable placeholder origin to resolve against.
const SAME_ORIGIN_BASE = 'https://albert.invalid';

/**
 * True when `path` is a safe same-origin destination to navigate to after login: a relative in-app
 * path (single leading "/") that resolves back to our own origin.
 *
 * Resolving through the `URL` parser normalizes the input the way the browser does — stripping ASCII
 * tabs/newlines and folding backslashes to slashes — so protocol-relative ("//host"), backslash- or
 * whitespace-tricked ("/\\host", "/\t//host"), and scheme URLs ("https://host", "javascript:…") all
 * resolve off-origin (or fail the leading-"/" check) and are rejected, preventing a stored or
 * query-supplied redirect from becoming an open redirect to an attacker-controlled origin.
 */
export function isSafeRedirectPath(path: unknown): path is string {
  if (typeof path !== 'string' || !path.startsWith('/')) {
    return false;
  }
  try {
    return new URL(path, SAME_ORIGIN_BASE).origin === SAME_ORIGIN_BASE;
  } catch {
    return false;
  }
}
